import { AbstractControl, FormArray, Validators } from '@angular/forms';
import { PersistentFormArray, PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { FormGroupValueOf } from '@utility/utility';
import {
    equalOrMoreThanTodayOnlyIfCRCDateValidator,
    maxLengthValidator,
    notWhitespaceValidator,
} from '@utility/utility.validators';
import { Moment } from 'moment';

export class TransferDataFormGroup extends PersistentFormGroup<{
    pickupDate: PersistentFormControl<Moment | null>;
    pickupTime: PersistentFormControl<number | null>;
    pickupAddress: PersistentFormControl<string | null>;
    dropoffAddress: PersistentFormControl<string | null>;
}> {
    public static create(value: FormGroupValueOf<TransferDataFormGroup>): TransferDataFormGroup {
        return new TransferDataFormGroup({
            pickupDate: new PersistentFormControl(value.pickupDate, [equalOrMoreThanTodayOnlyIfCRCDateValidator]),
            pickupTime: new PersistentFormControl(value.pickupTime),
            pickupAddress: new PersistentFormControl(value.pickupAddress, [
                Validators.required,
                notWhitespaceValidator(),
                maxLengthValidator(200),
            ]),
            dropoffAddress: new PersistentFormControl(value.dropoffAddress, [
                Validators.required,
                notWhitespaceValidator(),
                maxLengthValidator(200),
            ]),
        });
    }
}

export class CarServiceRequestDetailsFormGroup extends PersistentFormGroup<{
    transfers: PersistentFormArray<TransferDataFormGroup>;
    specialRequests: PersistentFormControl<string | null>;
}> {
    public static create(
        value: FormGroupValueOf<CarServiceRequestDetailsFormGroup>
    ): CarServiceRequestDetailsFormGroup {
        return new CarServiceRequestDetailsFormGroup({
            transfers: new PersistentFormArray(
                value.transfers.map((transfer) => TransferDataFormGroup.create(transfer)),
                [
                    (control: AbstractControl) => {
                        const array = control as FormArray;
                        if (array.length === 0)
                            return {
                                requiredAtLeastOneTransfer: 'You must add at least one transfer.',
                            };

                        return null;
                    },
                ]
            ),
            specialRequests: new PersistentFormControl(value.specialRequests, [
                notWhitespaceValidator(),
                maxLengthValidator(1000),
            ]),
        });
    }
}
